import React from "react";
import MenuItemLayout from "./MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { Collapse } from "antd";
import { data } from "../../../data/PrivacyPolicy";

const PrivacyPolicy = () => {
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      urlImage={banner}
      title="الرئيسية"
      subTitle="سياسة الخصوصية"
      className="takaful--privacy-policy"
    >
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests takaful--privacy-policy-container`}
        accordion
        defaultActiveKey={["0"]}
      >
        {data?.map((el, index) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel takaful--privacy-policy-panel"
            key={index}
            header={
              <div
                className="takaful--header-profile-container"
                style={{ direction: "rtl" }}
              >
                <p className="takaful--content-services-request-p">
                  {el.title}
                </p>
              </div>
            }
          >
            <div className="takaful--content-privacy-policy">
              <span className="takaful--content-services-request-span ">
                {el.content}
              </span>
              <ol style={{ marginRight: "2rem" }}>
                {el?.items?.map((element: any) => (
                  <li className="takaful--content-services-request-span">
                    {element}
                  </li>
                ))}
              </ol>
              <ul className="takaful--privacy-policy-list">
                {el?.contact?.map((element: any) => (
                  <li className="takaful--content-services-request-span">
                    {element}
                  </li>
                ))}
              </ul>
            </div>
          </Collapse.Panel>
        ))}
      </Collapse>
    </MenuItemLayout>
  );
};

export default PrivacyPolicy;
